import React, { useState, useEffect } from "react";
import {
  qhseBg,
  supplyDrill1,
  supplyDrill2,
  supplyDrill3,
  supplyDrill4,
} from "../../../../assets/images"; // Yeni görselleri burada ekle
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const DrillbitsSupply = () => {
  const { t } = useTranslation();

  const [heroHeight, setHeroHeight] = useState("300px");

  useEffect(() => {
    const updateHeight = () => {
      setHeroHeight(window.innerWidth < 640 ? "200px" : "300px");
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div
        className="relative bg-black/60 w-full"
        style={{
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: heroHeight,
        }}
      >
        <SubOtherHero title="Drill Bits" />
      </div>

      {/* Content Section */}
      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Content with 4 Images */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("DRILL BIT")}
            </p>
            <ul className="mt-5 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>
                {t("Drill bits comply to international standards of IADC.")}
              </li>
              <li>
                {t(
                  "Caspian Rock Solutions provide following types drill bits and services on its projects:"
                )}
              </li>
              <li>
                <strong>{t("DIAMOND DRILL BITS / PDC")}:</strong>{" "}
                {t(
                  "manufactured in different diametrs and mofidications. Applied in horizontal, S-shape and directional and complex wells."
                )}
              </li>
              <li>
                <strong>{t("ROLLER CONE BITS")}:</strong>{" "}
                {t(
                  "applied in different cases in offshore as well as onshore wells (hard rock, frequent interbedded seams, high silicification, high degree of abrasiveness and intensity of angle setting)."
                )}
              </li>
              <li>
                <strong>{t("DRILL BITS SERVICES")}:</strong>{" "}
                {t("experienced personnel, per meter rental.")}
              </li>
            </ul>
          </div>
          <div className="md:w-1/2 grid grid-cols-2 gap-4 mt-8 md:mt-0">
            <img
              src={supplyDrill1}
              alt="Drill Bit 1"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyDrill2}
              alt="Drill Bit 2"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyDrill3}
              alt="Drill Bit 3"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyDrill4}
              alt="Drill Bit 4"
              className="w-full rounded-lg shadow-md"
            />
          </div>
          {/* Right Text */}
        </div>
      </div>
    </>
  );
};

export default DrillbitsSupply;
